import React, { useState } from 'react';

export interface FileNode {
  name: string;
  type: 'file' | 'directory';
  path: string;
  size?: number;
  lastModified?: Date;
  children?: FileNode[];
}

interface FileTreeProps {
  files: FileNode[];
  onFileClick: (node: FileNode) => void;
}

const FileTree: React.FC<FileTreeProps> = ({ files, onFileClick }) => {
  const [expandedPaths, setExpandedPaths] = useState<Set<string>>(new Set());

  const toggleExpand = (node: FileNode, e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('FileTree: toggling expand for node:', node.path);
    setExpandedPaths(prev => {
      const next = new Set(prev);
      if (next.has(node.path)) {
        next.delete(node.path);
      } else {
        next.add(node.path);
        onFileClick(node);
      }
      return next;
    });
  };

  const handleNameClick = (node: FileNode, e: React.MouseEvent) => {
    e.stopPropagation();
    console.log('FileTree: name clicked for node:', node.path);
    if (node.type === 'directory') {
      toggleExpand(node, e);
    } else {
      onFileClick(node);
    }
  };

  const renderNode = (node: FileNode) => {
    const isExpanded = expandedPaths.has(node.path);

    return (
      <li key={node.path} className="py-1">
        <div className="flex items-center gap-2">
          {node.type === 'directory' && (
            <div
              onClick={(e) => toggleExpand(node, e)}
              className="w-4 text-center text-gray-600 cursor-pointer hover:text-gray-800"
            >
              {isExpanded ? '▼' : '▶'}
            </div>
          )}
          <div
            onClick={(e) => handleNameClick(node, e)}
            className={`flex-1 cursor-pointer hover:bg-gray-100 rounded px-2 py-1 ${
              node.type === 'directory' ? 'text-blue-600' : 'text-gray-800'
            }`}
          >
            {node.type === 'directory' ? '📁' : '📄'} {node.name}
          </div>
        </div>
        {node.type === 'directory' && isExpanded && node.children && (
          <ul className="ml-6 mt-1">
            {node.children.map(child => renderNode(child))}
          </ul>
        )}
      </li>
    );
  };

  return (
    <ul className="list-none pl-4">
      {files.map(node => renderNode(node))}
    </ul>
  );
};

export default FileTree; 